<template>
    <div>
        <CardFront>

            <!-- ── RedSys: redirigiendo a pasarela externa ── -->
            <template v-if="formulario">
                <div class="tw:text-center tw:py-8">
                    <i class="material-icons tw:text-5xl tw:text-indigo-500 tw:mb-4">lock</i>
                    <h4 class="tw:text-lg tw:font-bold tw:text-slate-800 tw:mb-2">
                        {{ t('perfil_invitaciones.redirigiendo_pago', {}, 'Redirigiendo a la pasarela de pago seguro...') }}
                    </h4>
                    <p class="tw:text-sm tw:text-slate-500 tw:mb-0">
                        {{ t('perfil_invitaciones.no_cerrar', {}, 'Por favor, no cierres esta página') }}
                    </p>
                    <div class="tw:mt-6 tw:flex tw:justify-center">
                        <div class="tw:w-8 tw:h-8 tw:border-4 tw:border-indigo-200 tw:border-t-indigo-500 tw:rounded-full tw:animate-spin"></div>
                    </div>
                </div>
                <div ref="redsysFormContainer" style="display: none;"></div>
            </template>

            <!-- ── Paycomet: flujo existente ── -->
            <template v-else>
                <h4 class="tw:flex tw:items-center tw:gap-2 tw:text-base tw:font-bold tw:text-slate-800 tw:m-0 tw:mb-5">
                    <i class="material-icons tw:text-lg tw:text-slate-600">credit_card</i>
                    {{ t('perfil_invitaciones.pago_titulo', {}, 'Pago con tarjeta') }}
                </h4>

                <div v-if="loading" class="tw:mx-auto tw:w-[325px] tw:h-[523px] tw:overflow-hidden tw:border tw:border-slate-200 tw:flex tw:flex-col tw:animate-pulse">
                    <div class="tw:h-[52px] tw:bg-slate-200 tw:shrink-0"></div>
                    <div class="tw:flex-1 tw:bg-white tw:flex tw:flex-col tw:items-center tw:px-6 tw:pt-5 tw:pb-4 tw:gap-3">
                        <div class="tw:h-3 tw:w-4/5 tw:bg-slate-200 tw:rounded"></div>
                        <div class="tw:h-10 tw:w-2/5 tw:bg-slate-200 tw:rounded tw:mt-1"></div>
                        <div class="tw:flex tw:items-center tw:gap-3 tw:w-full tw:justify-center tw:mt-1">
                            <div class="tw:w-10 tw:h-7 tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                            <div class="tw:h-3 tw:w-32 tw:bg-slate-200 tw:rounded"></div>
                        </div>
                        <div class="tw:h-3 tw:w-28 tw:bg-slate-200 tw:rounded"></div>
                        <div class="tw:flex tw:items-start tw:gap-2 tw:w-full tw:mt-2">
                            <div class="tw:w-3 tw:h-3 tw:bg-slate-200 tw:rounded-full tw:shrink-0 tw:mt-0.5"></div>
                            <div class="tw:flex tw:flex-col tw:gap-1 tw:flex-1">
                                <div class="tw:h-2.5 tw:w-full tw:bg-slate-200 tw:rounded"></div>
                                <div class="tw:h-2.5 tw:w-3/4 tw:bg-slate-200 tw:rounded"></div>
                            </div>
                        </div>
                        <div class="tw:flex-1"></div>
                        <div class="tw:w-24 tw:h-8 tw:bg-slate-200 tw:rounded tw:border tw:border-slate-300"></div>
                        <div class="tw:flex tw:flex-col tw:gap-1 tw:w-full tw:items-center">
                            <div class="tw:h-2.5 tw:w-4/5 tw:bg-slate-200 tw:rounded"></div>
                            <div class="tw:h-2.5 tw:w-3/5 tw:bg-slate-200 tw:rounded"></div>
                        </div>
                        <div class="tw:w-full tw:h-px tw:bg-slate-200 tw:mt-2"></div>
                        <div class="tw:flex tw:gap-3 tw:w-full tw:justify-between">
                            <div class="tw:h-9 tw:w-[44%] tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                            <div class="tw:h-9 tw:w-[44%] tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                        </div>
                    </div>
                </div>

                <div v-else-if="iframeUrl" class="tw:flex tw:justify-center tw:mb-4">
                    <iframe
                        :src="iframeUrl"
                        width="325"
                        height="523"
                        sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms"
                        class="tw:border-0"
                    ></iframe>
                </div>

                <PagoPaycometForm
                    v-else
                    ref="pagoFormRef"
                    :jet_id="jet_id"
                    @payToken="procesarPago"
                />

                <div
                    v-if="errorMsg"
                    class="tw:text-sm tw:text-red-600 tw:bg-red-50 tw:border tw:border-red-200 tw:rounded-xl tw:px-4 tw:py-3 tw:mb-4"
                >
                    {{ errorMsg }}
                </div>

                <Button
                    v-if="!iframeUrl && !loading"
                    variant="alt"
                    custom-class="tw:w-full tw:py-3.5 tw:text-sm tw:rounded-xl tw:mb-3"
                    @click="submitForm"
                >
                    {{ t('perfil_invitaciones.pagar', { total: formatearPrecio(amount) }, 'Pagar ' + formatearPrecio(amount)) }}
                    <i class="material-icons tw:text-sm">lock</i>
                </Button>

                <div v-if="!iframeUrl && !loading" class="tw:flex tw:justify-center">
                    <Button variant="ghost" custom-class="tw:w-full tw:py-3.5 tw:text-slate-400 tw:hover:text-slate-600" @click="emit('cancelar')">
                        {{ t('perfil_invitaciones.pago_cancelar', {}, 'Cancelar y volver') }}
                    </Button>
                </div>
            </template>

        </CardFront>

        <div class="tw:flex tw:items-start tw:sm:items-center tw:gap-2 tw:mt-4 tw:px-2">
            <i class="material-icons tw:text-slate-400 tw:text-base tw:mt-0.5 tw:shrink-0">shield</i>
            <p class="tw:text-xs tw:text-slate-400 tw:m-0 tw:pt-1 tw:leading-relaxed">
                {{ t('perfil.cambio_datos.seguridad_texto', {}, 'Pago seguro mediante protocolo encriptado SSL') }}
            </p>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, onMounted, onUnmounted } from 'vue';
    import { t } from '@/utils/i18n-helper';
    import { useFilters } from '@/composables/front/formatters/useFilters';
    import { useStepperPago } from '@/composables/front/perfil/generarInvitaciones/useStepperPago.js';
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import PagoPaycometForm from '@/modules/front/perfil/components/CambiarDatos/PagoPaycometForm.vue';

    const props = defineProps({
        jet_id:     { type: String, default: null },
        formulario: { type: String, default: null },
        session_id: { type: String, required: true },
        amount:     { type: Number, required: true },
    });

    const emit = defineEmits(['completado', 'cancelar']);

    const { formatearPrecio } = useFilters();

    const pagoFormRef = ref(null);
    const redsysFormContainer = ref(null);

    const { loading, iframeUrl, errorMsg, resultado, procesarPago, reiniciar } = useStepperPago(props.session_id);

    const submitForm = () => {
        pagoFormRef.value?.submit();
    };

    // ── RedSys: inyectar formulario HTML y auto-submit ──
    onMounted(() => {
        if (props.formulario && redsysFormContainer.value) {
            redsysFormContainer.value.innerHTML = props.formulario;
            setTimeout(() => {
                const form = redsysFormContainer.value.querySelector('form');
                if (form) form.submit();
            }, 100);
        }
    });

    // Watch for payment completion
    watch(resultado, val => {
        if (val) {
            emit('completado', val);
        }
    });

    // Cleanup on unmount
    onUnmounted(() => {
        reiniciar();
    });
</script>
